var map = {
	"./action_image.png": 318,
	"./dimond.png": 319,
	"./logo_01.png": 49,
	"./logo_02.png": 189,
	"./logo_03.png": 190,
	"./logo_04.png": 50,
	"./logo_05.png": 51,
	"./p_feature1.png": 320,
	"./prototype_banner_img.png": 321,
	"./prototype_banner_img2.png": 322,
	"./psd.png": 323,
	"./saas.png": 324,
	"./tab.png": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1080;